/* global __BUILD_ENV__ */
Object.assign(process.env, __BUILD_ENV__);
